import { AdbSubprocessService, type Adb } from "@yume-chan/adb";

/** Run a shell command on the connected device via ADB subprocess service */
export async function shellCmd(adb: Adb, command: string[]): Promise<string> {
  const svc = new AdbSubprocessService(adb);
  const shell = svc.shellProtocol;
  if (shell) {
    const result = await shell.spawnWaitText(command);
    return result.stdout + result.stderr;
  }
  return svc.noneProtocol.spawnWaitText(command);
}
